module.exports = __webpack_public_path__ + "../resources/img/logo.1d350c73.svg";